import type { MagentoApiSetAdditionalAttributesOutput } from "@jti/magento-api-v2";

import type { MagentoApiBuilder } from "../magentoApiSlice";

type SetAdditionalAttributesPayload = {
  cartId: string;
  additionalAttributes: Array<{ attribute_code: string; value: string }>;
};

export const setAdditionalAttributesEndpoint = (builder: MagentoApiBuilder) => ({
  setAdditionalAttributes: builder.mutation<MagentoApiSetAdditionalAttributesOutput, SetAdditionalAttributesPayload>({
    query: ({ cartId, additionalAttributes }) => ({
      method: "setAdditionalAttributes",
      params: [{ cartId, additionalAttributes }],
    }),
  }),
});
